import React from 'react'
import './App.css'
import AppRouter from './routes/routes'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { GlobalStateProvider } from "./context/GlobalStateProvider";
export default function App (props) {

 
  return (
    <GlobalStateProvider>
      <AppRouter />
      <ToastContainer icon={false} autoClose={5000} hideProgressBar={true} />{" "}
      </GlobalStateProvider>
  )
}

